<template>
  <div class="mensagens">
    <nav-menu></nav-menu>

    <div class="w3-main w3-animate-left" style="margin-top: 43px;">
      <div class="w3-container w3-white" id="mensagens">
        <h5 class="w3-padding" v-cloak>
          <b><i class="fa fa-envelope"></i> Mensagens</b>
        </h5>
        <div class="w3-center"></div>

        <div class="w3-container menu-tab" style="padding:0px 8px">
          <div class="w3-row-padding">
            <div class="w3-bar w3-white w3-border">
              <div class="w3-col s4 m2">
                <button 
                  class="w3-bar-item w3-button w3-theme botao-quadrado w3-split-hover w3-hover-theme nova-mensagem" 
                  style="width: 100%;padding:8px 0px" 
                  v-on:click="mostrarModalEnviarMensagem()">
                  <i class="fa fa-envelope"></i>
                  Nova
                </button>
              </div>
              
              <div class="w3-col s4 m5">
                <button 
                  class="w3-bar-item w3-theme-inverse-black tablink tab-active active botao-quadrado" 
                  style="width: 100%;padding:8px 0px" 
                  onclick="mudarAba(event, 'recebidos')">
                  <i class="fa fa-sign-in-alt"></i>  <b>Recebidas</b>
                </button>
              </div>
              <div class="w3-col s4 m5">
                <button 
                  class="w3-bar-item w3-theme-inverse-black  tablink tab-active botao-quadrado" 
                  id="consultar-mensagens" 
                  style="width: 100%;padding:8px 0px"
                  onclick="mudarAba(event, 'enviados')">
                  <i class="fa fa-search"></i>
                  <b>Consulta</b>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Inicio da aba de recebidos -->
        <div id="recebidos" class="aba w3-container w3-animate-left w3-margin-top" style="padding:0px">
          <div class="w3-row-padding">
            <div class="w3-col s12  w3-margin-bottom">
              <h3 class="titulo w3-text-theme"><span>Recebidas</span></h3>
            </div>
            <div class="w3-col s12 m12 l12 w3-margin-bottom">
              <label>Filtro</label>
              <input 
                class="w3-input w3-border w3-padding" 
                type="text" 
                placeholder="Pesquise por assunto, código ou nome do funcionário de origem" 
                v-model="filtro_mensagens" 
                v-on:keyup="filtrarMensagens()">
            </div>

            <div class="w3-panel  w3-col s12" v-if="processando">
              <p class="w3-theme w3-card-2  w3-col s12 w3-padding">
                <i class="fa fa-sync-alt w3-spin "></i> Processando...
              </p>
            </div>

            <div 
              class="w3-col w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left"
              v-if="(Object.keys(mensagens_filtradas).length === 0) && 
              !processando" 
              v-cloak>
              <div class="w3-container w3-white">
                <p>Não há mensagens a serem exibidas.</p>
              </div>
            </div>
            
            <div class="mensagens-recebidas-total">
              <div 
                class="w3-row-padding row-mensagens-recebidas w3-animate-left w3-col s12" 
                v-show="mensagens_filtradas != null" 
                v-for="(mensagem, mensagem_index) in mensagens_filtradas" :key="mensagem_index" v-cloak>
                <div v-bind:class="getClasseMensagem(mensagem.nova, mensagem.ver_mensagem)">
                  <div class="w3-container" style="padding:10px 5px">
                    <div class="w3-col s12">
                      <i v-bind:class="getClasseTextoMensagem(mensagem.nova, mensagem.ver_mensagem)"></i>
                      <label
                        class="label-clicavel" 
                        v-on:click="mostrarTextoMensagem(mensagem.mensagem_id)">
                        <strong>{{mensagem.nome_usuario_origem}}</strong>
                      </label>
                      
                      <label 
                        class="w3-right label-clicavel"
                        v-on:click="mostrarTextoMensagem(mensagem.mensagem_id)">
                        {{mensagem.data_hora_mensagem}} 
                        <small class="w3-tiny">{{mensagem.hora_mensagem}}</small>
                      </label>
                      
                      <p 
                        style="margin: 0; padding:0; font-size: 12px; font-weight: bold;" 
                        id="assunto" 
                        class="label-clicavel" 
                        v-on:click="mostrarTextoMensagem(mensagem.mensagem_id)">
                        {{getAssuntoResumido(mensagem.assunto, !mensagem.ver_mensagem)}}
                      </p>
                      
                      <p 
                        style="margin: 0; padding:0; font-size: 12px" 
                        class="label-clicavel" 
                        v-on:click="mostrarTextoMensagem(mensagem.mensagem_id)">
                        
                        <span v-show="!mensagem.ver_mensagem">{{getTextoResumido(mensagem.texto)}}</span>
                        <span class="w3-right">
                          <i style="color: #dd0000" class="fa fa-circle" v-if="mensagem.importante == 'S'"></i>
                          <i style="color: #0a9286" class="fa fa-circle" v-if="mensagem.exigir_resposta == 'S'"></i>
                        </span>
                      </p>
                      
                      <div v-show="mensagem.ver_mensagem" class="w3-center">
                        <div class="texto-auto-expansivel w3-white w3-border w3-animate-left w3-margin-bottom">
                          <pre class="box-mensagem">{{mensagem.texto}}</pre>
                        </div>
                        
                        <button 
                          class="w3-button w3-theme w3-animate-left w3-tiny" 
                          style="width: 40px" 
                          v-on:click="mostrarReponderMensagem(mensagem.mensagem_id, false)"
                          :disabled="mensagem.responder_mensagem ||
                          mensagem.permitir_resposta=='N'">
                          <i class="fa fa-reply w3-center"></i>
                        </button>
                        
                        <button 
                          class="w3-button w3-theme w3-animate-left w3-tiny confirmar-leitura"
                          style="width: 40px" 
                          v-on:click="confirmarLeituraMensagem(mensagem.mensagem_id)" 
                          :disabled="mensagem.exigir_resposta=='S' &&
                          mensagem.respondida=='N'">
                          <i class="fa fa-check"></i>
                        </button>
                        
                        <div class=" w3-dropdown-hover w3-center w3-animate-left">
                          <button 
                            class="w3-button w3-theme w3-tiny" 
                            :disabled="mensagem.responder_mensagem" 
                            style="width: 40px">
                            <i class="fa fa-ellipsis-v"></i>
                          </button>
                          
                          <div 
                            class="w3-dropdown-content w3-bar-block w3-border"
                            :disabled="mensagem.responder_mensagem" 
                            style="right:0">
                            <button
                              class="w3-bar-item w3-button"
                              @click="mostrarReponderMensagem(mensagem.mensagem_id, true)"
                              :disabled="mensagem.permitir_resposta=='N'">
                              <i class="fa fa-reply-all icone-vermelho"></i>  Responder todos
                            </button>
                            <button 
                              class="w3-bar-item w3-button"
                              :disabled="mensagem.grupo_mensagens_id == 0"
                              @click="buscarUsuariosMensagem(mensagem.grupo_mensagens_id)">
                              <i class="fa fa-users icone-vermelho"></i>  Ver todos os destinatários
                            </button>
                            
                            <button 
                              class="w3-bar-item w3-button" 
                              @click="mostrarModalEncaminharMensagem(mensagem.assunto, 
                              mensagem.texto, 
                              mensagem.nome_usuario_origem, 
                              mensagem.data_hora_mensagem, 
                              mensagem.hora_mensagem,
                              mensagem.nome_usuario_destino)">
                              <i class="fa fa-paper-plane icone-vermelho"></i>  Encaminhar
                            </button>
                          </div>
                        </div>
                      </div>
                      <div v-show="mensagem.responder_mensagem" class="w3-center">
                        <br>
                        <textarea 
                          class="w3-border w3-animate-left" 
                          style="width:100%;"
                          rows="5"
                          v-model="mensagem_responder_texto">
                        </textarea>

                        <button 
                          class="w3-button w3-theme w3-animate-left w3-small"
                          style="width:100px"
                          v-on:click="responderMensagem(mensagem.mensagem_id, false)">
                          <i class="fa fa-send w3-center"></i> Enviar
                        </button>
                        
                        <button 
                          class="w3-button w3-text-theme w3-white w3-animate-left w3-small w3-border"
                          style="width:100px"
                          v-on:click="mostrarReponderMensagem(mensagem.mensagem_id)">
                          <i class="fa fa-ban w3-center"></i> Cancelar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="w3-center w3-display-container w3-col s12 w3-margin-bottom w3-padding-24" v-cloak>
                <button 
                  class="w3-button w3-theme w3-display-middle"
                  v-if="((existe_mais) &&
                  !(processando) && 
                  (mensagens_filtradas.length > 0))" 
                  v-on:click="carregarMaisMensagensRecebidas()">Carregar mais
                </button>
              </div>
            </div>
            <button 
              id="floating-button"
              title="Atualizar mensagens"  
              class="w3-button w3-theme w3-circle w3-display-bottomright"
              v-on:click="buscarMensagens()">
              <i class="fa fa-sync-alt"/>
            </button>
          </div>
        </div>

        <div id="enviados" class="aba w3-container w3-animate-left w3-margin-top" style="display:none; padding:0px">
          <div class="w3-row-padding">
            <div class="w3-col s12  ">
              <h3 class="titulo w3-text-theme"><span>Consulta de mensagens</span></h3>
            </div>
            
            <div class="w3-col s12 m6 l4 w3-margin-top">
              <label>Usuário de origem</label>
              <input
                class="w3-input w3-border w3-padding"
                type="text"
                v-model="usuario_origem_filtro"
                v-on:keyup="filtrarMensagens()">
            </div>
            
            <div class="w3-col s12 m6 l4 w3-margin-top">
              <label>Usuário de destino</label>
              <input 
                class="w3-input w3-border w3-padding" 
                type="text"
                v-model="usuario_destino_filtro"
                v-on:keyup="filtrarMensagens()">
            </div>

            <div class="w3-col s12 m6 l4 w3-margin-top">
              <label>Assunto</label>
              <input 
                class="w3-input w3-border w3-padding" 
                type="text" 
                v-model="assunto_filtro"
                v-on:keyup="filtrarMensagens()">
            </div>

            <div class="w3-col s12 m6 l12 w3-margin-top">
              <label>Texto</label>
              <input 
                class="w3-input w3-border w3-padding"
                type="text" v-model="texto_filtro"
                v-on:keyup="filtrarMensagens()">
            </div>

            <div class="w3-half w3-col s12 m6 l6 w3-margin-top">
              <label>Data início</label>
              <input
                class="w3-input"
                type="date"
                maxlength="10"
                placeholder="Dia/Mês/Ano"
                v-model="data_periodo_inicial"
                id="data_inicial" 
                onkeyup="FormataDataDiaMesAno(this,'##/##/####',event)"/>
            </div>

            <div class="w3-half  w3-col s12 m6 l6 w3-margin-top">
              <label>Data final</label>
              <input
                class="w3-input"
                type="date" 
                maxlength="10" 
                placeholder="Dia/Mês/Ano"
                v-model="data_periodo_final"
                id="data_final" 
                onkeyup="FormataDataDiaMesAno(this,'##/##/####',event)"/>
            </div>
            
            <div class=" w3-center w3-col">
              <button 
                class="w3-button w3-theme w3-center"
                id="btProcessarMensagensEnviadas" 
                v-on:click="buscarMensagensEnviadas()"
                :disabled="processando">
                Processar
              </button>
            </div>

            <div class="w3-panel  w3-col s12" v-if="processando">
              <p class="w3-theme w3-card-2  w3-col s12 w3-padding">
                <i class="fa fa-sync-alt w3-spin "></i> Processando...
              </p>
            </div>
            
            <div class="w3-margin-top w3-col s12 mensagens-recebidas" style="padding:0"> 
              <div 
                class="w3-row-padding row-mensagens-recebidas w3-animate-left w3-col s12" 
                v-for="(mensagem, mensagem_index) in mensagens_filtradas_enviadas"
                :key="mensagem_index" 
                v-cloak>
                
                <div v-bind:class="getClasseMensagemEnviada(mensagem.verificada, mensagem.ver_mensagem, mensagem)">
                  <div class="w3-container" style="padding:10px 5px">
                    <div class="w3-col s12">
                      <i v-bind:class="getClasseTextoMensagemEnviada(mensagem.verificada, mensagem.ver_mensagem, mensagem)"></i>
                      <label 
                        class="label-clicavel" 
                        v-on:click="mostrarTextoMensagemEnviada(mensagem.mensagem_id)">
                        <strong>
                          {{mensagem.nome_usuario_origem}} 
                          &nbsp;<i class="fa fa-long-arrow-alt-right"></i>&nbsp;
                          {{mensagem.nome_usuario_destino}}
                        </strong>
                      </label>
                      
                      <label 
                        class="w3-right label-clicavel" 
                        v-on:click="mostrarTextoMensagemEnviada(mensagem.mensagem_id)">
                        {{mensagem.data_hora_mensagem}} - <small>{{mensagem.hora_mensagem}}</small>
                      </label>

                      <p 
                        style="margin: 0; padding:0; font-size: 12px; font-weight: bold;" 
                        id="assunto" 
                        class="label-clicavel" 
                        v-on:click="mostrarTextoMensagemEnviada(mensagem.mensagem_id)">
                        {{getAssuntoResumido(mensagem.assunto, !mensagem.ver_mensagem)}}
                      </p>

                      <p 
                        style="margin: 0; padding:0; font-size: 12px" 
                        class="label-clicavel"
                        v-on:click="mostrarTextoMensagemEnviada(mensagem.mensagem_id)">
                        
                        <span v-show="!mensagem.ver_mensagem">{{getTextoResumido(mensagem.texto)}}</span>
                        <span class="w3-right">
                          <i style="color: #dd0000" class="fa fa-circle" v-if="mensagem.importante == 'S'"></i>
                          <i style="color: #0a9286" class="fa fa-circle" v-if="mensagem.exigir_resposta == 'S'"></i>
                        </span>
                      </p>
                      
                      <div v-show="mensagem.ver_mensagem" class="w3-center">
                        <div class="texto-auto-expansivel w3-white w3-border w3-animate-left w3-margin-bottom" style="font-family: roboto">
                          <pre>{{mensagem.texto}}</pre>
                        </div>
                        
                        <button 
                          class="w3-button w3-theme w3-animate-left w3-tiny" 
                          style="width: 40px" 
                          v-on:click="mostrarReponderMensagemFiltrada(mensagem.mensagem_id, false)" 
                          :disabled="mensagem.responder_mensagem || 
                          mensagem.permitir_resposta=='N'">
                          <i class="fa fa-reply w3-center"></i>
                        </button>
                        
                        <div class=" w3-dropdown-hover w3-center w3-animate-left">
                          <button 
                            class="w3-button w3-theme w3-tiny" 
                            :disabled="mensagem.responder_mensagem" 
                            style="width: 40px">
                            <i class="fa fa-ellipsis-v"></i>
                          </button>
                          
                          <div 
                            class="w3-dropdown-content w3-bar-block w3-border" 
                            :disabled="mensagem.responder_mensagem" 
                            style="right:0">
                            <button 
                              class="w3-bar-item w3-button"
                              @click="mostrarReponderMensagemFiltrada(mensagem.mensagem_id, true)"
                              :disabled="mensagem.permitir_resposta=='N'">
                              <i class="fa fa-reply-all icone-vermelho"></i>  Responder todos
                            </button>
                            
                            <button
                              class="w3-bar-item w3-button"
                              :disabled="mensagem.grupo_mensagens_id == 0"
                              @click="buscarUsuariosMensagem(mensagem.grupo_mensagens_id)">
                              <i class="fa fa-users icone-vermelho"></i>  Ver todos os destinatários
                            </button>
                            
                            <button 
                              class="w3-bar-item w3-button"
                              @click="mostrarModalEncaminharMensagem(mensagem.assunto,
                              mensagem.texto, 
                              mensagem.nome_usuario_origem, 
                              mensagem.data_hora_mensagem,
                              mensagem.hora_mensagem, 
                              mensagem.nome_usuario_destino)">
                              <i class="fa fa-paper-plane icone-vermelho"></i>  Encaminhar
                            </button>
                          </div>
                        </div>
                      </div>
                      
                      <div v-show="mensagem.responder_mensagem" class="w3-center">
                        <br>
                        <textarea 
                          class="w3-border w3-animate-left" 
                          style="width:100%;" 
                          rows="5" 
                          v-model="mensagem_responder_texto">
                        </textarea>

                        <button 
                          style="width:100px" 
                          class="w3-button w3-theme w3-animate-left w3-small" 
                          v-on:click="responderMensagem(mensagem.mensagem_id, true)">
                          <i class="fa fa-send w3-center"></i> Enviar
                        </button>
                        
                        <button
                          style="width:100px" 
                          class="w3-button w3-text-theme w3-white w3-animate-left w3-small w3-border" 
                          v-on:click="mostrarReponderMensagemFiltrada(mensagem.mensagem_id)">
                          <i class="fa fa-ban w3-center"></i> Cancelar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="w3-center w3-display-container w3-col s12 w3-margin-bottom w3-padding-24" v-cloak>
              <button 
                class="w3-button w3-theme w3-display-middle"
                v-if="((existe_mais) &&
                !(processando) && 
                (mensagens_filtradas_enviadas.length > 0))"
                v-on:click="carregarMaisMensagensEnviadas()">Carregar mais
              </button>
            </div>
          </div>
        </div>

        <div id="modalUsuariosMensagem" class="w3-modal">
          <div class="w3-modal-content ">
            <header class="w3-container">
              <span onclick="document.getElementById('modalUsuariosMensagem').style.display='none'"
                class="w3-button w3-display-topright w3-text-theme w3-large w3-text-theme w3-large">&times;</span>
                <h2 class="titulo">Usuários da mensagem</h2>
            </header><br>
            
            <div class="w3-container" style="max-height: calc(100vh - 200px);overflow: auto">
              <table class="w3-table-all">
                <thead>
                  <tr>
                    <th></th>
                    <th>Usuário</th>
                    <th>Nome</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(usuario, usuario_index) in usuarios_mensagem" :key="usuario_index">
                    <td>
                      <img 
                        v-if="false"
                        class="w3-circle w3-border w3-margin-bottom w3-center"
                        style="width: 3rem; height: 3rem; background-size: cover;"
                        v-bind:src="buscarFotoUsuarioLocal(usuario.usuario_destino_id)">
                    </td>
                    <td>{{usuario.usuario_destino_id}}</td>
                    <td>{{usuario.nome_usuario_destino}}</td>
                  </tr>
                </tbody>
              </table>
              <br>
            </div>
          </div>
        </div>
      </div>
		</div><!-- w3-main -->

    <!-- Inicio modal de enviar mensagens -->
    <div id="modalEnviarMensagem" class="w3-modal">
      <div class="w3-modal-content " id="modalEnviarMensagem">
        <header class="w3-container">
          <span @click="fecharModal('modalEnviarMensagem')" class="w3-button w3-display-topright w3-text-theme w3-large">&times;</span>
          <h2 class="titulo" id="cabecalho_mensagem"></h2>
        </header>
        
        <div class="w3-container">
          <div class="w3-col w3-display-container">
            <strong 
              style="line-height:40px;"> 
              Usuários selecionados 
            </strong>
            
            <button 
              class="btn-usuarios w3-btn w3-theme w3-display-topright" 
              style="border-top-right-radius: 8px;" 
              v-on:click="mostrarModalUsuarios()">
              <i class="fa fa-user-plus"></i>
            </button>

            <p  v-show="usuarios_selecionados.length == 0" style='margin:0 0 -15px 0'>Não há usuários selecionados.</p>
            <div style="max-height: 200px; overflow: auto" class="w3-margin-top w3-margin-bottom">
              <table class="w3-table w3-border w3-bordered w3-striped w3-white usuariosSelecionados " v-show="usuarios_selecionados.length > 0">
                <thead class="w3-hide-small">
                  <th>Usuário</th>
                  <th>Nome</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr v-for="(usuario, usuario_index) in usuarios_selecionados" :key="usuario_index">
                    <td class="w3-hide-small" >{{usuario.funcionario_id}}</td>
                    <td >{{usuario.nome}}</td>
                    <td 
                      class="w3-center" 
                      style="line-height: 15px">
                      <button 
                        class="w3-button w3-theme w3-tiny"
                        v-on:click="adicionarRemoverUsuario(usuario.funcionario_id, true)">
                        <i class="fa fa-times"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="w3-container">
          <strong>Assunto: </strong>
          <input 
            type="text" 
            class="w3-input w3-block w3-border"
            style="text-transform: uppercase;" 
            v-model="assuntoEnviar"
            v-on:keyup="assuntoEnviar = assuntoEnviar.toUpperCase()" 
            id="assunto-enviar">
          <br>
          <strong>Mensagem: </strong>
          <textarea 
            class="w3-input w3-block w3-border" 
            style="resize:none" 
            maxlength="4000" 
            rows="5" 
            v-model="mensagemEnviar" 
            id="mensagem-enviar">
          </textarea>
          
          <br>
          <input 
            class="w3-check" 
            type="checkbox"
            name="permitir_resposta"
            id="permitir_resposta" 
            checked="checked"
            v-model="mensagem_permitir_resposta">
          <label for="permitir_resposta">
            <strong>Permitir resposta</strong>
          </label>
        </div>

        <footer class="w3-container">
          <button
            class="w3-button w3-theme botao-100 btn-enviar" 
            id="btn-confirmar-acao" 
            style="margin-top: 10px; margin-bottom:10px" 
            v-on:click="enviar_mensagem()"
            :disabled="enviando_mensagem">Enviar
          </button>
          
          <button 
            class="w3-button w3-text-theme w3-border w3-right botao-100"
            style="margin-top: 10px; margin-bottom:10px"
            @click="fecharModal('modalEnviarMensagem')" 
            :disabled="enviando_mensagem">
            Cancelar
          </button>
        </footer>

      </div>

      <div id="modalInserirUsuarios" class="w3-modal">
        <div class="w3-modal-content ">

          <header class="w3-container">
            <span 
              onclick="document.getElementById('modalInserirUsuarios').style.display='none'"
              class="w3-button w3-display-topright w3-text-theme w3-large">
              &times;
            </span>
            <h2 class="titulo">Usuários disponíveis</h2>
          </header>

          <div class="w3-container">
            <div class="w3-col">
              <input 
                class="w3-input w3-border w3-padding w3-col s12 m10 w3-margin-top w3-margin-bottom input-pesquisa" 
                type="text"
                placeholder="Pesquise por código ou nome do usuário"
                autofocus 
                v-model="filtro_usuarios"
                @change="eventFiltrarUsuarios" 
                @input="eventFiltrarUsuarios" 
                id="pesquisa_usuario">
                
              <div class="w3-col s12 m12 campo-check">
                <input
                  class="w3-check w3-margin-bottom" 
                  name="fotos_usuarios" 
                  id="fotos_usuarios" 
                  type="checkbox" 
                  checked="checked" 
                  v-model="buscar_fotos_usuarios">
                <label for="fotos_usuarios">
                  <strong>Mostrar fotos</strong>
                </label>
              </div>

              <div class="w3-col s12 m12 campo-check">
                <input
                  type="checkbox"
                  checked="checked"
                  class="w3-check w3-margin-bottom"
                  id="ck_somente_usuarios_conectados"
                  v-on:click="buscarFuncionarios(!somente_usuarios_conectados)"
                  v-model="somente_usuarios_conectados">
                <label for="ck_somente_usuarios_conectados">
                  <strong>Somente usuários conectados</strong>
                </label>
              </div>
              
              <div class="w3-responsive w3-border  w3-col s12" style="max-height: calc(100vh - 320px);min-height: 200px;overflow: auto">
                <table class="w3-table w3-border w3-bordered w3-white">
                  <thead>
                    <th v-if="buscar_fotos_usuarios"></th>
                    <th>Usuário</th>
                    <th>Nome</th>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="(usuario, usuario_index) in usuarios_disponiveis_filtrados" 
                      :key="usuario_index"
                      :class="getClasseUsuarioDisponivel(usuario.adicionado)" 
                      :data-usuario="usuario.funcionario_id">
                      
                      <td 
                        v-on:click="mostrarModalFotoFuncionario(usuario.funcionario_id)"
                        v-if="buscar_fotos_usuarios" 
                        class="w3-animate-left">
                        <img 
                          style="width: 3rem; height: 3rem; background-size: cover" 
                          v-bind:src="buscarFotoUsuarioLocal(usuario.funcionario_id)" 
                          class="w3-circle w3-border w3-margin-bottom w3-center">
                      </td>
                      <td v-on:click="adicionarRemoverUsuario(usuario.funcionario_id, usuario.adicionado)">{{usuario.funcionario_id}}</td>
                      <td v-on:click="adicionarRemoverUsuario(usuario.funcionario_id, usuario.adicionado)">{{usuario.nome}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <footer class="w3-container conteudo-centralizado">
            <button 
              class="w3-btn w3-theme btn-confirmar-usuarios"
              id="btn-confirmar-acao"
              style="margin-top: 10px; margin-bottom:10px" 
              onclick="document.getElementById('modalInserirUsuarios').style.display='none'">
              <i class="fas fa-check-circle"/> Ok
            </button>
          </footer>
        </div>
      </div>

      <div 
        id="modalFotoFuncionario"
        class="w3-modal  w3-center" 
        onclick="this.style.display='none'">
        <img 
          class="w3-modal-content" 
          style="max-width: 400px; height: auto" 
          v-bind:src="foto_funcionario_zoom">
      </div>
    </div>
    <!-- Fim do modal de enviar mensagens -->

	</div>
</template>

<script>
  import NavMenu from '@/components/Menu';
  import toastr from 'toastr';
  import RMensagem from '@/components/Rest/RMensagem.js';
  import RFuncionario from '@/components/Rest/RFuncionario.js';
  import Biblioteca from '@/components/Repositorio/Biblioteca.js';

  export default {
    name: 'Mensagens',
    components: {
      NavMenu
    },
    data() {
      return {
        api: process.env.API,
        mensagens: '',
        mensagens_usuario: {},
        mensagens_filtradas: [],
        mensagens_todas_filtradas: [],
        mensagens_enviadas: {},
        mensagens_filtradas_enviadas: [],
        mensagem_responder_id: 0,
        mensagem_responder_todos_id: 0,
        mensagem_assunto_resonder: '',
        mensagem_responder_texto: '',
        filtro_usuarios_cons_mensagem: '',
        mensagem_assunto: '',
        processando: false,
        filtro_mensagens: '',
        data_periodo_inicial: '',
        data_periodo_final: '',
        usuario_origem_filtro: '',
        usuario_destino_filtro: '',
        assunto_filtro: '',
        texto_filtro: '',
        existe_mais: true,
        quant_mensagens_rec_carregadas: 0,
        usuarios_mensagem: [],
        assunto_resposta: '',
        usuarios_selecionados: [],
        usuarios_disponiveis: [],
        mensagem_enviar: {},
        mensagem_permitir_resposta: true,
        buscar_fotos_usuarios: false,
        somente_usuarios_conectados: true,
        enviando_mensagem: false,
        filtro_usuarios: '',
        usuarios_disponiveis_filtrados: [],
        foto_funcionario_zoom: '',
        mensagemEnviar: '',
        assuntoEnviar: '',
        fotos_usuarios: []
      }
    },
    methods: {
      eventFiltrarUsuarios({type, target}) {
        const event = {
          type,
          isCheckbox: target.type === 'checkbox',
          target: {
            value: target.value,
            checked: target.checked
          }
        }

        this.filtro_usuarios = event.target.value
        this.filtrarUsuarios()
      },

      recarregarComponente(){
        Object.assign(this.$data, this.$options.data.call(this))
      },

      async buscarMensagens() {
        this.processando = true;
        this.mensagens_usuario = {};
        this.mensagens_filtradas = [];
        this.quant_mensagens_rec_carregadas = 10;

        try {
          let retorno = await RMensagem.buscarMensagensUsuario(this.axios, 0);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          let msg_usuario = retorno.dados.data.mensagens;
        
          for (let i = 0; i < msg_usuario.length; i++) {
            msg_usuario[i].ver_mensagem = false;
            msg_usuario[i].responder_mensagem = false;
            msg_usuario[i].texto = msg_usuario[i].texto.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));
          }

          this.quant_mensagens_rec_carregadas = 10;
          this.mensagens_usuario = msg_usuario;

          let quant_mensagens_novas = 0;
          
          if (this.quant_mensagens_rec_carregadas > this.mensagens_usuario.length) {
            this.quant_mensagens_rec_carregadas = this.mensagens_usuario.length
            this.existe_mais = false;
          }
          else {
            this.existe_mais = true;
          }

          for (let i = 0; i < this.quant_mensagens_rec_carregadas; i++) {
            this.mensagens_filtradas.push(this.mensagens_usuario[i]);
            if (this.mensagens_usuario[i].nova == 'S') {
              quant_mensagens_novas += 1;
            }
          }

          if (quant_mensagens_novas == 1) {
            toastr.success('Existe ' + quant_mensagens_novas + ' nova mensagem.');
          }
          else if (quant_mensagens_novas > 1) {
            toastr.success('Existem ' + quant_mensagens_novas + ' novas mensagens.');
          }

          this.mensagens_todas_filtradas = this.mensagens_filtradas;

          if (
            (this.usuarios_disponiveis_filtrados) && 
            (this.usuarios_disponiveis_filtrados.length > 0)
          ) {
            for (let i = 0; i < this.usuarios_disponiveis_filtrados.length; i++) {
              this.usuarios_disponiveis_filtrados[i].adicionado = false
            }
          }

          this.processando = false;
        } 
        catch (erro) {
          this.processando = false;
        }
      },

      TratarWebErroJSONLocal: function(data){
        TratarWebErroJSON(data)
      },
      
      async buscarMensagensEnviadas() {
        if (this.data_periodo_inicial == '') {
          toastr.error('É necessário informar a data do período inicial da consulta!');
          document.getElementById('data_inicial').focus();
          return;
        }

        if (this.data_periodo_final == '') {
          toastr.error('É necessário informar a data do período final da consulta!');
          document.getElementById('data_final').focus();
          return;
        }

        if (!validarData(this.data_periodo_inicial)){
          toastr.error('Não foi possível validar a data inicial inserida!');
          document.getElementById('data_inicial').focus();
          return;
        }

        if (!validarData(this.data_periodo_final)){
          toastr.error('Não foi possível validar a data final inserida!');
          document.getElementById('data_final').focus();
          return;
        }

        this.processando = true;
        this.mensagens_enviadas = {};
        this.mensagens_filtradas_enviadas = [];

        let parametros = {
          data_inicial: Biblioteca.fData(this.data_periodo_inicial),
          data_final: Biblioteca.fData(this.data_periodo_final),
          usuario_origem: this.usuario_origem_filtro.trim(),
          usuario_destino: this.usuario_destino_filtro.trim(),
          assunto: this.assunto_filtro.trim(),
          texto: this.texto_filtro.trim()
        }

        try {
          let retorno = await RMensagem.pesquisarMensagens(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.processando = false
          let mensagens = retorno.dados.data.mensagens;
      
          if (mensagens.length == 0) {
            toastr.info('Nenhuma mensagem foi encontrada respeitando os filtros informados.');
          }

          for (let i = 0; i < mensagens.length; i++) {
            mensagens[i].ver_mensagem = false;
            mensagens[i].responder_mensagem = false;

            /* Substituir \n por quebra de linha */
            mensagens[i].texto = mensagens[i].texto.replace(
              /\\n/g, 
              String.fromCharCode(13) + String.fromCharCode(10)
            )
          }

          this.quant_mensagens_rec_carregadas = 20;
          this.mensagens_enviadas = mensagens;

          if (this.quant_mensagens_rec_carregadas > this.mensagens_enviadas.length) {
            this.quant_mensagens_rec_carregadas = this.mensagens_enviadas.length
            this.existe_mais = false;
          }
          else
            this.existe_mais = true;

          for (let i = 0; i < this.quant_mensagens_rec_carregadas; i++) {
            this.mensagens_filtradas_enviadas.push(this.mensagens_enviadas[i]);
          }
        } 
        catch (error) {
          console.log(error)
          toastr.error(error.message);
          this.processando = false;
        }
      },

      atualizarMensagens: function(msg_usuario){
        for (var i = 0; i < msg_usuario.mensagens.length; i++) {
          msg_usuario.mensagens[i].ver_mensagem = false;
          msg_usuario.mensagens[i].responder_mensagem = false;
        }

        this.quant_mensagens_rec_carregadas = 10;
        this.mensagens_usuario = msg_usuario;
        var quant_mensagens_novas = 0;
        // Criando uma nova instancia o array de mensagens. Se colocar simplesmente um objeto igual ao outro vai acabar sendo por referência.
        //this.mensagens_filtradas = this.mensagens_usuario.slice(0);

        if (this.quant_mensagens_rec_carregadas > this.mensagens_usuario.length){
          this.quant_mensagens_rec_carregadas = this.mensagens_usuario.length
          this.existe_mais = false;
        }
        else
          this.existe_mais = true;

        for (var i = 0; i < this.quant_mensagens_rec_carregadas; i++) {
          this.mensagens_filtradas.push(this.mensagens_usuario[i]);
          if (this.mensagens_usuario[i].nova == 'S')
            quant_mensagens_novas += 1;
        }

        if (quant_mensagens_novas > 0)
          toastr.success('Existe(m) ' + quant_mensagens_novas + ' nova(s) mensagem(ns)!');

        this.mensagens_todas_filtradas = this.mensagens_filtradas;
        this.processando = false;
      },
      carregarMaisMensagensRecebidas: function(){
        var quant_ja_carregada = this.quant_mensagens_rec_carregadas;

        this.quant_mensagens_rec_carregadas += 10;

        if (this.quant_mensagens_rec_carregadas > this.mensagens_usuario.length){
          this.quant_mensagens_rec_carregadas = this.mensagens_usuario.length
          this.existe_mais = false;
        }
        else
          this.existe_mais = true;

        for (var i = quant_ja_carregada; i < this.quant_mensagens_rec_carregadas; i++) {
          this.mensagens_filtradas.push(this.mensagens_usuario[i]);
        }
      },
      atualizarMensagensEnviadas: function(mensagem){
        if (mensagem.mensagens.length == 0)
          toastr.info('Nenhuma mensagem foi encontrada respeitando os filtros informados.');

        for (var i = 0; i < mensagem.mensagens.length; i++) {
          mensagem.mensagens[i].ver_mensagem = false;
          mensagem.mensagens[i].responder_mensagem = false;
        }

        this.quant_mensagens_rec_carregadas = 20;
        this.mensagens_enviadas = mensagem;

        if (this.quant_mensagens_rec_carregadas > this.mensagens_enviadas.length){
          this.quant_mensagens_rec_carregadas = this.mensagens_enviadas.length
          this.existe_mais = false;
        }
        else
          this.existe_mais = true;

        for (var i = 0; i < this.quant_mensagens_rec_carregadas; i++) {
          this.mensagens_filtradas_enviadas.push(this.mensagens_enviadas[i]);
        }

        this.processando = false;
      },
      carregarMaisMensagensEnviadas: function(){
        var quant_ja_carregada = this.quant_mensagens_rec_carregadas;

        this.quant_mensagens_rec_carregadas += 20;

        if (this.quant_mensagens_rec_carregadas > this.mensagens_enviadas.length){
          this.quant_mensagens_rec_carregadas = this.mensagens_enviadas.length
          this.existe_mais = false;
        }
        else
          this.existe_mais = true;

        for (var i = quant_ja_carregada; i < this.quant_mensagens_rec_carregadas; i++) {
          this.mensagens_filtradas_enviadas.push(this.mensagens_enviadas[i]);
        }
      },
      mostrarModalEnviarMensagem: function(){
        document.getElementById("cabecalho_mensagem").innerHTML="Enviar mensagem";
        this.assuntoEnviar = '';
        this.mensagemEnviar = '';
        document.getElementById("modalEnviarMensagem").style.display = "block";
      },
      mostrarModalResponderMensagem: function(mensagem_id, assunto){
        this.mensagem_responder_id = mensagem_id;
        this.assunto_resposta = assunto;
        document.getElementById("modalResponderMensagem").style.display = "block";
      },
      mostrarModalResponderMensagemTodos: function(mensagem_id, assunto){
        this.mensagem_responder_todos_id = mensagem_id;
        this.assunto_resposta = assunto;
        document.getElementById("modalResponderMensagemTodos").style.display = "block";
      },
      mostrarModalEncaminharMensagem: function(encaminhar_assunto, encaminhar_texto, usuario_origem,data_mensagem, hora_mensagem, usuario_destino){
        var texto_mensagem = '----------Mensagem original---------- \n' + 'De: ' + usuario_origem + " - " + data_mensagem + " "+ hora_mensagem + '\n' +
          'Para: ' + usuario_destino + '\n\n' + encaminhar_texto;

        document.getElementById("cabecalho_mensagem").innerHTML="Encaminhar mensagem";
        this.assuntoEnviar = 'Enc: ' + encaminhar_assunto.toUpperCase();
        this.mensagemEnviar = texto_mensagem.slice(0, 3900);
        document.getElementById("modalEnviarMensagem").style.display = "block";
      },
      fecharModal(id){
        for(let i = 0; i < this.usuarios_disponiveis_filtrados.length ; i++){
          for(let j=0 ; j < this.usuarios_selecionados.length; j++){
            if(numeros(this.usuarios_selecionados[j].funcionario_id) == this.usuarios_disponiveis_filtrados[i].funcionario_id)
            this.usuarios_disponiveis_filtrados[i].adicionado = false;
          }
        }
        for(let i = 0; i < this.usuarios_disponiveis.length ; i++){
          for(let j=0 ; j < this.usuarios_selecionados.length; j++){
            if(numeros(this.usuarios_selecionados[j].funcionario_id) == this.usuarios_disponiveis[i].funcionario_id)
            this.usuarios_disponiveis[i].adicionado = false;
          }
        }
        this.usuarios_selecionados = [];
        document.getElementById(id).style.display = "none";
      },

      responderMensagem: function(mensagemId, recarregarConsulta){
        if (this.mensagem_responder_id > 0){
          if (this.mensagem_responder_texto == ''){
            toastr.error("É necessário informar a mensagem!");
            return;
          }

          this.enviarMensagem(
            this.mensagem_responder_id,
            this.mensagem_responder_texto,
            "N"
          );
        }
        else{
          if (this.mensagem_responder_texto == ''){
            toastr.error("É necessário informar a mensagem!");
            return;
          }

          this.enviarMensagem(
            this.mensagem_responder_todos_id,
            this.mensagem_responder_texto,
            "S"
          );
        }
        if (recarregarConsulta) {
          this.mensagens_filtradas_enviadas = [];
          this.buscarMensagensEnviadas();
        }
      },

      async confirmarLeituraMensagem(mensagem_id){
        try {
          let parametros = {
            mensagem_id: mensagem_id
          }

          let retorno = await RMensagem.confirmarLeituraMensagem(this.axios, parametros, false);
          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }
          
          if (retorno && retorno.data && retorno.data.houve_erro == 'N')
              toastr.success('Confirmação de leitura efetuada com sucesso.');
            else{
              console.log(retorno)
            }
        } catch (error) {
          toastr.error(error.retorno.mensagem);
          return;
        }

        for (let i = 0; i < this.mensagens_filtradas.length; i++) {
          if(this.mensagens_filtradas[i].mensagem_id == mensagem_id){
            this.mensagens_filtradas.splice(i, 1);
            break;
          }
        }

        for (let i = 0; i < this.mensagens_usuario.length; i++) {
          if(this.mensagens_usuario[i].mensagem_id == mensagem_id){
            this.mensagens_usuario.splice(i, 1);
            break;
          }
        }

        this.quant_mensagens_rec_carregadas = this.quant_mensagens_rec_carregadas - 1;
      },

      async verificarLeitura(mensagem_id){   
        try {
          let parametros = {
            mensagem_id: mensagem_id
          }
          await RMensagem.marcarMensagemLida(this.axios, parametros);
        } 
        catch (error) {
          toastr.warning('Ocorreu um erro ao confirmar leitura da mensagem!');
          return;
        }
      },
      
      modalInserirUsuariosOrigem: function(){
        this.filtro_usuarios_cons_mensagem = '';
        this.filtrarUsuariosConsultaMensagens();
        document.getElementById("modalInserirUsuariosOrigem").style.display = "block";
      },
      
      modalInserirUsuariosDestino: function(){
        this.filtro_usuarios_cons_mensagem = '';
        this.filtrarUsuariosConsultaMensagens();
        document.getElementById("modalInserirUsuariosDestino").style.display = "block";
      },
      
      async buscarUsuariosMensagem(grupo_mensagem_id) {
        try {
          let parametros = {
            grupo_mensagem_id: grupo_mensagem_id
          }

          let retorno = await RMensagem.buscarUsuariosGrupoMensagens(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }
          
          this.usuarios_mensagem = JSON.parse(JSON.stringify(retorno.dados.data.usuarios));
          if (this.usuarios_mensagem.length == 0) {
            toastr.info('Não há outros destinatários para esta mensagem.');
            return;
          }

          for (let i = 0; i < this.usuarios_mensagem.length; i++) {
            if (!this.buscarFotoUsuarioLocal(this.usuarios_mensagem[i].usuario_destino_id)) {
              await this.buscarFotoFuncionario(this.usuarios_mensagem[i].usuario_destino_id);
            }
          }

          document.getElementById("modalUsuariosMensagem").style.display = "block";
        } 
        catch (error) {
          toastr.error(
            'Ocorreu um erro ao buscar os usuários da mensagem. ' + 
            'Recarregue a página e tente novamente.'
          );
        }
      },

      async enviarMensagem(mensagem_id, mensagem_texto, responder_todos) {
        if (!mensagem_texto.trim() || mensagem_texto.length == 0){
          toastr.error("É necessário informar uma mensagem!");
          return;
        }

        try {
          let parametros = {
            mensagem_id: mensagem_id,
            mensagem_texto: mensagem_texto.slice(0, 4000),
            responder_todos: responder_todos
          };

          let retorno = await RMensagem.responderMensagem(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }
          else {
            toastr.success('Resposta enviada com sucesso.');
            this.buscarMensagens();
          }
        } 
        catch (error) {
          toastr.error('Ocorreu um erro ao enviar mensagem.');
          this.recarregarComponente();
          return;
        }

        this.mensagem_responder_id = 0;
        this.mensagem_responder_texto = '';
        this.mensagem_responder_todos_id = 0;
      },

      filtrarMensagens: function(){
        this.mensagens_filtradas = [];

        if  (this.filtro_mensagens == '')
          this.mensagens_filtradas = this.mensagens_todas_filtradas;
        else{
          for (let i = 0; i < this.mensagens_usuario.length; i++) {
            if (this.mensagens_usuario[i].assunto.toUpperCase().indexOf(this.filtro_mensagens.toUpperCase()) > -1){
              this.mensagens_filtradas.push(this.mensagens_usuario[i])
            }

            if ((this.mensagens_usuario[i].nome_usuario_origem.toUpperCase().indexOf(this.filtro_mensagens.toUpperCase()) > -1)){
              this.mensagens_filtradas.push(this.mensagens_usuario[i])
            }

            if (this.mensagens_usuario[i].usuario_origem_id == this.filtro_mensagens){
              this.mensagens_filtradas.push(this.mensagens_usuario[i])
            }
          }
        }
      },
      getClasseMensagem: function(nova, ver_mensagem){
        if (ver_mensagem)
          return "card-mensagem-ver-local";
        else if(nova == 'S')
          return "card-mensagem-nova-local";
        else
          return "card-mensagem-ver-local";
      },
      getClasseMensagemEnviada: function(verificada, ver_mensagem){
        if (ver_mensagem) {
          return "card-mensagem-ver-local";
        }
        else if(verificada == 'N')
          return "card-mensagem-nova-local";
        else
          return "card-mensagem-ver-local";
      },
      getClasseTextoMensagem: function(nova, ver_mensagem){
        if (ver_mensagem)
          return 'fas fa-check-double';
        else if(nova == 'S')
          return 'fas fa-comments';
          
        else
          return 'fas fa-check-double';
      },
      getClasseTextoMensagemEnviada: function(verificada, ver_mensagem){
        if (ver_mensagem) {
          return  'fas fa-check-double';
        }
        else if(verificada == 'N')
          return 'fas fa-comments';
        else
          return 'fas fa-check-double';
      },
      getTextoResumido: function(texto){
        if(window.innerWidth < 400)
          return (texto.slice(0, 40) + "...")
        else
          return (texto.slice(0, 100) + "...");
      },
      getAssuntoResumido: function(assunto, resumir){
        if (assunto == undefined)
          return;

        if (resumir)
          if(window.innerWidth < 400)
            return (assunto.slice(0, 40) + "...");
          else
            if(assunto.length > 200)
              return (assunto.slice(0, 60) + "...");
            else
              return assunto;
        else
          return assunto;
      },
      mostrarTextoMensagem: function(mensagem_id){
        for (var i = 0; i < this.mensagens_filtradas.length; i++) {
          if (this.mensagens_filtradas[i].responder_mensagem){
            this.mensagens_filtradas[i].responder_mensagem = false;
            this.mensagem_responder_id = 0;
            this.mensagem_responder_todos_id = 0;
            this.mensagem_responder_texto = '';
          }

          if (this.mensagens_filtradas[i].mensagem_id == mensagem_id){
            if (this.mensagens_filtradas[i].nova == 'S'){
              this.mensagens_filtradas[i].nova = 'N';
              this.verificarLeitura(mensagem_id);
            }
            this.mensagens_filtradas[i].ver_mensagem = !this.mensagens_filtradas[i].ver_mensagem;
          }
          else{
            this.mensagens_filtradas[i].ver_mensagem = false;
          }
        }
      },
      mostrarTextoMensagemEnviada: function(mensagem_id){
        for (var i = 0; i < this.mensagens_filtradas_enviadas.length; i++) {

          if (this.mensagens_filtradas_enviadas[i].mensagem_id == mensagem_id){
            if (this.mensagens_filtradas_enviadas[i].verificada == 'N'){
              this.mensagens_filtradas_enviadas[i].verificada = 'S';
              this.verificarLeitura(mensagem_id);
            }

            this.mensagens_filtradas_enviadas[i].ver_mensagem = !this.mensagens_filtradas_enviadas[i].ver_mensagem;
          }
          else{
            this.mensagens_filtradas_enviadas[i].ver_mensagem = false;
          }
        }
      },
      mostrarReponderMensagem: function(mensagem_id, responder_todos){
        for (var i = 0; i < this.mensagens_filtradas.length; i++) {
          if (this.mensagens_filtradas[i].mensagem_id == mensagem_id){
            this.mensagens_filtradas[i].responder_mensagem = !this.mensagens_filtradas[i].responder_mensagem;

            if (!responder_todos)
              this.mensagem_responder_id = mensagem_id;
            else
              this.mensagem_responder_todos_id = mensagem_id;

            this.mensagem_responder_texto = '';
            break;
          }
        }
      },
      mostrarReponderMensagemFiltrada: function(mensagem_id, responder_todos){
        for (var i = 0; i < this.mensagens_filtradas_enviadas.length; i++) {
          if (this.mensagens_filtradas_enviadas[i].mensagem_id == mensagem_id){
            this.mensagens_filtradas_enviadas[i].responder_mensagem = !this.mensagens_filtradas_enviadas[i].responder_mensagem;

            if (!responder_todos)
              this.mensagem_responder_id = mensagem_id;
            else
              this.mensagem_responder_todos_id = mensagem_id;

            this.mensagem_responder_texto = '';
            break;
          }
        }
      },
      adicionarRemoverUsuario: function(funcionario_id, adicionado){
        /* Caso o usuário já tenha sido adicionado, removendo*/
        if (adicionado){
          for (var i = 0; i < this.usuarios_selecionados.length; i++) {
            if (this.usuarios_selecionados[i].funcionario_id == funcionario_id){
              this.usuarios_selecionados.splice(i, 1);
              break;
            }
          }

          for (var i = 0; i < this.usuarios_disponiveis.length; i++) {
            if (this.usuarios_disponiveis[i].funcionario_id == funcionario_id){
              this.usuarios_disponiveis[i].adicionado = false;
              break;
            }
          }

          for (var i = 0; i < this.usuarios_disponiveis_filtrados.length; i++) {
            if (this.usuarios_disponiveis_filtrados[i].funcionario_id == funcionario_id){
              this.usuarios_disponiveis_filtrados[i].adicionado = false;
              break;
            }
          }
        }
        /* Caso contrário, adicionado */
        else {
          var usuario_selecionado = {};
          var disponivel = false;

          usuario_selecionado.funcionario_id = funcionario_id;

          if (usuario_selecionado.funcionario_id == undefined){
            toastr.error("É necessário selecionar o usuário!");
            return;
          }

          for (var i = 0; i  < this.usuarios_disponiveis_filtrados.length; i++) {
            if(this.usuarios_disponiveis_filtrados[i].funcionario_id == funcionario_id){
              this.usuarios_disponiveis_filtrados[i].adicionado = true;
              disponivel = true;
              break;
            }
          }

          for(let i=0 ; i < this.usuarios_selecionados.length; i++){
            disponivel = (this.usuarios_selecionados[i].funcionario_id == usuario_selecionado.funcionario_id) ? false : disponivel;
          }

          let usuario_filtrado = this.usuarios_disponiveis.filter( usuario => {
            return usuario.funcionario_id == usuario_selecionado.funcionario_id
          })

          this.usuarios_selecionados.push(usuario_filtrado[0])
        }
      },
      getClasseUsuarioDisponivel: function(adicionado){
        if (adicionado)
          return 'w3-theme label-clicavel';
        else
          return 'w3-white label-clicavel';
      },
      
      async buscarFuncionarios(somente_usuarios_conectados) {
        try {
          this.filtro_usuarios = '';

          let parametros = {
            somente_usuarios_conectados: somente_usuarios_conectados ? 'S' : 'N'
          };

          let retorno = await RFuncionario.buscarUsuariosConectados(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          for (var i = 0; i < retorno.dados.length; i++) {
            retorno.dados[i].adicionado = false;
          }

          this.usuarios_disponiveis = JSON.parse(JSON.stringify(retorno.dados));
          this.usuarios_disponiveis_filtrados = JSON.parse(JSON.stringify(retorno.dados));
        }
        catch (erro) {
          console.log('erro', JSON.stringify(erro))
        }
      },

      async enviar_mensagem() {
        let texto_mensagem = this.mensagemEnviar;
        let assunto_mensagem = this.assuntoEnviar.toUpperCase();

        if (this.usuarios_selecionados.length == 0){
          toastr.error('Selecione um usuário!');
          return;
        }

        if (!texto_mensagem.trim() || texto_mensagem.length === 0){
          toastr.error('Preencha a mensagem!');
          return;
        }

        this.enviando_mensagem = true;
        
        let parametros = {};
        parametros.assunto = assunto_mensagem.slice(0, 400);
        parametros.texto = texto_mensagem.slice(0, 4000);

        if (this.mensagem_permitir_resposta) {
          parametros.permitir_resposta = 'S';
        }
        else {
          parametros.permitir_resposta = 'N';
        }
        
        parametros.usuarios_ids = [];
        for (let i = 0; i < this.usuarios_selecionados.length; i++) {
          parametros.usuarios_ids.push(this.usuarios_selecionados[i].funcionario_id);
        }
        
        try {
          await RMensagem.enviarMensagem(this.axios, parametros);
          this.usuarios_selecionados = [];

          for (let j = 0; j  < this.usuarios_disponiveis.length; j++) {
            this.usuarios_disponiveis[j].adicionado = false;
          }

          this.enviando_mensagem = false;

          document.getElementById('modalEnviarMensagem').style.display = 'none';
          toastr.success('Mensagem enviada com sucesso.');
          //this.recarregarComponente();

          this.assuntoEnviar = this.mensagemEnviar = '';

          this.buscarMensagens();
        } catch (error) {
          return;
        }
      
      },

      buscarFotoUsuarioLocal(funcionario_id) {
        if ((!this.fotos_usuarios) || (this.fotos_usuarios.length == 0)) {
          return undefined;
        }

        for (let i = 0; i < this.fotos_usuarios.length; i++) {
          if (this.fotos_usuarios[i].funcionario_id != funcionario_id) {
            continue;
          }

          return this.fotos_usuarios[i].foto;
        }

        return undefined;
      },
      
      mostrarModalFotoFuncionario: function(funcionario_id){
        this.foto_funcionario_zoom = this.buscarFotoUsuarioLocal(funcionario_id)
        document.getElementById('modalFotoFuncionario').style.display = "block";
      },
      
      mostrarModalUsuarios: function(){
        document.getElementById('modalInserirUsuarios').style.display = "block";
      },
      
      filtrarUsuarios: function() {
        this.usuarios_disponiveis_filtrados = [];

        if  (this.filtro_usuarios == '')
          this.usuarios_disponiveis_filtrados = this.usuarios_disponiveis;
        else{
          for (var i = 0; i < this.usuarios_disponiveis.length; i++) {

            if (this.usuarios_disponiveis[i].nome.toUpperCase().indexOf(this.filtro_usuarios.toUpperCase()) > -1){
              this.usuarios_disponiveis_filtrados.push(this.usuarios_disponiveis[i])
            }

            if (this.usuarios_disponiveis[i].funcionario_id == this.filtro_usuarios){
              this.usuarios_disponiveis_filtrados.push(this.usuarios_disponiveis[i])
            }
          }
        }
      },

      async buscarFotoFuncionario(funcionario_id) {
        let retorno = this.buscarFotoUsuarioLocal(funcionario_id);
        if (retorno) {
          return retorno;
        }

        try {
          let parametros = {
            funcionario_id: funcionario_id
          };

          let retorno_servidor = await RFuncionario.buscarFotoFuncionario(this.axios, parametros);
          if (retorno_servidor.houve_erro != 'N') {
            throw new Error(retorno_servidor.mensagem);
          }

          retorno = 'data:image/jpeg;base64,' + retorno_servidor.dados.foto;
        } catch (error) {
          retorno = 'static/imagens/foto_padrao_usuario.jpg';
        }

        this.fotos_usuarios.push(
          {
            funcionario_id: funcionario_id,
            foto: retorno
          }
        );

        return retorno;
      },

      fDataInternacional(date) {
        let d = new Date(date)
        let month = '' + (d.getMonth() + 1)
        let day = '' + d.getDate()
        let year = d.getFullYear()

        if (month.length < 2) 
          month = '0' + month;
        if (day.length < 2) 
          day = '0' + day;

        return [year, month, day].join('-');
      }
    },
    mounted: function() {
      let data_inicial = new Date();
      data_inicial.setDate(data_inicial.getDate() - 2);

      this.data_periodo_inicial = this.fDataInternacional(data_inicial);
      this.data_periodo_final =  this.fDataInternacional(new Date());
          
      this.buscarFuncionarios(true)
    },
    created: function () {
      toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-bottom-left",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
      };

      this.buscarMensagens();

    },
  };
</script>

<style scoped>
.card-mensagem-ver-local {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363 !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #636363 !important;
    background: #F1EFEF;
    color:#636363;
}
.card-mensagem-ver-local:hover {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363 !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #636363 !important;
    background: #636363;
    color: #F1EFEF;
}
.card-mensagem-nova-local {
    margin-bottom: 10px;
    border-left-style: solid;
    border-color: #9c1d1c !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #9c1d1c !important;
    transition: all 0.3s ease-out;
    color: #9c1d1c;
}
.card-mensagem-nova-local:hover {
    margin-bottom: 10px;
    border-left-style: solid;
    border-color: #9c1d1c  !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #9c1d1c !important;
    transition: all 0.3s ease-out;
    color: white;
    background-color: #9c1d1c;
}
	.box-mensagem {
    padding: 0 10px
  }
  #cabecalho_mensagem, .titulo{
     border-bottom:1px solid #8d1007;
  }

  #btProcessarMensagensEnviadas{
    margin-top:40px;
  }

  .input-pesquisa{
    border: 2px solid #ccc !important;
  }
  .campo-check{
    margin: 20px 0 16px 16px;
    float:left;
  }
  .usuariosSelecionados td, #modalInserirUsuarios table{
    line-height: 30px;
  }
  @media screen and (max-width: 767px){
    h2{
      font-size: 24px;
      margin-top:0;
      margin-bottom:15px;
    }
    .usuariosSelecionados td, #modalInserirUsuarios table {
      font-size: 13px;
      line-height: 15px !important;
      vertical-align: middle !important;
    }
    #btProcessarMensagensEnviadas{
      margin-top:20px;
    }
    .campo-check{
      margin: 0;
    }
    .input-pesquisa{
      margin-top:0px !important;
    }
    #mensagens .menu-tab button i{
      width: 100%;
    }
  }
  @media screen and (max-width: 320px){
    #mensagens{ padding: 0 }
  }
  @media screen and (min-width: 1180px){
    #mensagens .tablink {
      cursor:pointer;
    }
    #mensagens .menu-tab button i{
      margin-right: 15px;
    }
  }

    ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd;
  }

  ::-webkit-scrollbar-thumb {
    background: #8d1007;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c;
  }

   #floating-button {
    z-index: 5 !important;
    padding-left: 14px!important; 
    padding-top: 7px!important; 
    font-size: 19px; 
    border-radius: 30px; 
    width:55px; 
    height:55px; 
    border: 4px solid #f7f7f7!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  #floating-button:hover {
    color: #9c1d1c!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Mensagens.vue